import React, { useState, ReactNode } from 'react';

interface TabsProps {
  children: ReactNode;
}

interface TabContextType {
  activeIndex: number;
  setActiveIndex: (index: number) => void;
}

export const TabContext = React.createContext<TabContextType | null>(null);

const Tabs: React.FC<TabsProps> = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleActiveIndex = (index: number) => {
    setActiveIndex(index);
  };

  const value = {
    activeIndex,
    setActiveIndex: handleActiveIndex,
  };

  return (
    <TabContext.Provider value={value}>
      <div
        id="tabs-container"
        className="flex h-full min-h-0 w-full flex-col gap-y-2 overflow-visible p-2"
      >
        {children}
      </div>
    </TabContext.Provider>
  );
};

export default Tabs;
